import { List, useRecordContext } from "react-admin";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { grants } from "../../backoffice.access_control";
import { Row } from "../../misc/Row";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { RoomsDataGrid } from "./RoomsDataGrid";

export function DrivingSchoolRooms() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Räume</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <div style={{ position: "relative" }}>
      <Row justifyContent="space-between" alignItems="center" sx={{ mb: "30px", minHeight: "32px" }}>
        <PageTitle documentTitle="Räume">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>Räume</h2>
        </PageTitle>
        {grants.has("Room:create") && (
          <Button variant="outlined" startIcon={<AddIcon />} onClick={() => navigate("/rooms/create")} size="small">
            Hinzufügen
          </Button>
        )}
      </Row>
      <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolRooms">
        <List
          resource="rooms"
          title=" "
          actions={false}
          filter={{ drivingSchoolId: drivingSchool.id }}
          sort={/* initial sort order: */ { field: "name", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          empty={empty}
        >
          <RoomsDataGrid drivingSchool={drivingSchool} empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
